/* unplugin-vue-components disabled */
import Column from 'primevue/column'
import {DataTable} from 'components/data-table'
import EditModal from './edit-modal.vue'
import AddModal from './add-modal.vue'
import $shcompanies from 'stores/sh-companies'
import MergeModal from './merge-modal.vue'

const LIMIT = 20

export default {
  components: {
    EditModal,
    AddModal,
    DataTable,
    Column,
    MergeModal
  },
  data() {
    return {
      loading: true,
      load_params: {skip: 0, limit: LIMIT, filter: ''},
    }
  },
  computed: {
    total(){
      return $shcompanies.total
    },
    view_items(){
      return $shcompanies.view_items
    },
    view_total(){
      return $shcompanies.view_total
    },
    refreshing() {
      return $shcompanies.loading
    },
    highlight () {
      return this.load_params.filter
    }
  },
  async mounted() {
    this.loading = true
    await $shcompanies.load(this.load_params)
    this.loading = false
  },
  methods: {
    async onPage(ev){
      this.load_params = {...this.load_params, skip: ev.first, limit: ev.rows}
      await $shcompanies.load(this.load_params)
    },
    async onCopyId(id) {
      await $utils.copyText(id)
    },
    async onSearch(filter){
      if (this.load_params.filter === filter) return
      this.load_params = {skip: 0, limit: LIMIT, filter}    
      await $shcompanies.load(this.load_params)
      this.$refs.search.focus()
    },
    onAddCompany() {
      this.$refs.addModal.open()
    },
    openMerge(id){
      const shc = $shcompanies.getCompany(id)
      this.$refs.mergeModal.open(shc)
    },
    onEditCompany(id) {
      const shc = $shcompanies.getCompany(id)
      this.$refs.editModal.open(shc)
    },
    async onNewCompany(data) {
      try {
        await $shcompanies.newCompany(data)
        await $shcompanies.load(this.load_params)
        $utils.toasts.success('Company added successfully')
      }
      catch(err) {
        $utils.toasts.error(`Failed to add company: ${err}`)
      }
      this.$refs.addModal.close(true)
    },
    async onUpdateCompany(data) {
      const shc = $shcompanies.getCompany(data.id)
      const old_name = shc.name
      const old_lid  = shc.linkedin_id
      const old_wsurl = shc.website_url
      
      try {
        shc.name = data.name
        shc.linkedin_id = data.linkedin_id
        shc.website_url = data.website_url
        await shc.save()
        $utils.toasts.success('Company updated successfully')
      }
      catch(err) {
        $utils.toasts.error(`Failed to update company: ${err}`)
        shc.name = old_name
        shc.linkedin_id = old_lid
        shc.website_url = old_wsurl
      }
      this.$refs.editModal.close(true)
    },
    async onUploadLogo(company_id, file) {
      if (!file) {
        return
      }
      const shc = $shcompanies.getCompany(company_id)
      await shc.uploadLogo(file)
      $utils.toasts.success(`Logo for ${shc.name} uploaded successfully`)
    },

    async onMergeCompany(data){
      await $shcompanies.mergeCompanies(data)
      this.$refs.mergeModal.close(true)
      await $shcompanies.load(this.load_params)
    }
  }
}
